// Use WordPress's jQuery (enqueued as a script dependency, not bundled).
import $ from 'jquery';
import { getScrollbarWidth } from './helpers';

// Import Foundation modules
import 'foundation-sites/dist/js/plugins/foundation.core.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.touch.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.nest.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.box.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.motion.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.imageLoader.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.reveal.min.js';
import 'foundation-sites/dist/js/plugins/foundation.accordion.min.js';
import 'foundation-sites/dist/js/plugins/foundation.accordionMenu.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.tooltip.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.offcanvas.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.drilldown.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.sticky.min.js';
import 'foundation-sites/dist/js/plugins/foundation.tabs.min.js';
import 'foundation-sites/dist/js/plugins/foundation.dropdownMenu.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.dropdown.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.orbit.min.js';

// Launch Foundation
$(document).foundation();

// Set global scrollbar width
document.documentElement.style.setProperty(
    '--scrollbar-width',
    getScrollbarWidth() + 'px'
);

// Import custom modules
import './modules/Lenis';
import './modules/AjaxPosts';
import './modules/SmoothScroll';
import './modules/ObjectFitIE';
import './modules/Search';
import './modules/Animation';
// import './modules/Splide';
// import './modules/Newsletter';
import './modules/MobileMenu';
import './modules/StickyHeader';
import './modules/ViewSwitch';
import './modules/Algolia';
import './modules/Modal';
